import { render, staticRenderFns } from "./AdvancedPromotions.vue?vue&type=template&id=84e63038&scoped=true&"
import script from "./AdvancedPromotions.vue?vue&type=script&lang=js&"
export * from "./AdvancedPromotions.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedPromotions.vue?vue&type=style&index=0&id=84e63038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e63038",
  null
  
)

export default component.exports